import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.8799 19.52L12.8799 3.47C12.5299 2.84 11.4899 2.84 11.1399 3.47L2.12994 19.52C1.95994 19.83 1.95994 20.21 2.12994 20.51C2.30994 20.81 2.63994 21 2.98994 21H21.0099C21.3599 21 21.6899 20.81 21.8699 20.51C22.0499 20.2 22.0499 19.83 21.8699 19.52H21.8899H21.8799ZM4.68994 19.01L12.0099 6L19.3199 19.01H4.69994H4.68994ZM10.9999 9.59H12.9999V14.59H10.9999V9.59ZM10.9999 15.34H12.9999V17.34H10.9999V15.34Z" fill={ fill || 'currentColor' } />
    </svg>
);
